var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftEntraId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7329 31.8283C17.3365 32.2047 18.3398 32.6232 19.4007 32.6232C20.3667 32.6232 21.2642 32.3432 22.0078 31.8656C22.0078 31.8656 22.0094 31.8656 22.0109 31.864L24.8187 30.1094V36.4452C24.3738 36.4452 23.9258 36.3238 23.5369 36.0812L16.7329 31.8283Z",
    fill: "#225086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0346 12.3434L11.368 25.5034C10.4673 26.5207 10.7022 28.0576 11.8704 28.7871C11.8704 28.7871 16.1886 31.486 16.7331 31.8267C17.3366 32.2031 18.34 32.6216 19.4008 32.6216C20.3668 32.6216 21.2644 32.3416 22.008 31.864C22.008 31.864 22.0095 31.864 22.0111 31.8625L24.8188 30.1078L18.0304 25.8642L24.8204 18.2047V11.5547C24.1608 11.5547 23.5013 11.8176 23.0346 12.3434Z",
    fill: "#66DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0298 25.8646L18.1107 25.9144L24.8182 30.1082H24.8198V18.2066L24.8182 18.2051L18.0298 25.8646Z",
    fill: "#CBF8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7677 28.7873C38.9359 28.0578 39.1708 26.5209 38.2701 25.5036L30.6152 16.8687C29.9977 16.5809 29.3055 16.416 28.5728 16.416C27.1339 16.416 25.8475 17.0367 24.9919 18.012L24.8224 18.2033L31.6108 25.8629L24.8208 30.1065V36.4422C25.2672 36.4422 25.7121 36.3209 26.101 36.0782L37.7677 28.7858V28.7873Z",
    fill: "#074793"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8204 11.5547V18.2047L24.99 18.0134C25.8455 17.038 27.132 16.4174 28.5708 16.4174C29.3051 16.4174 29.9957 16.5838 30.6133 16.87L26.6015 12.3449C26.1364 11.8191 25.4768 11.5562 24.8188 11.5562L24.8204 11.5547Z",
    fill: "#0294E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6092 25.865L24.8208 18.207V30.107L31.6092 25.865Z",
    fill: "#96BCC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEntraId);
export default __webpack_public_path__ + "static/media/MicrosoftEntraID.2f0df7675d4333f8377d6198a0b0ce09.svg";
export { ForwardRef as ReactComponent };